<template>
  <div class="tab-panel">
    <slot>
    </slot>
  </div>
</template>
<script type="text/ecmascript-6">
const COMPONENT_NAME = 'tab-panel'
export default {
  name: COMPONENT_NAME,
  props: {
    label: {
      type: [String, Number],
      required: true
    }
  },
  mounted () {
    this.$parent.addPanel(this)
  },
  destroyed () {
    this.$parent.removePanel(this)
  }
}
</script>
<style lang="scss">
  .tab-panel {
    width: 100%;
    flex: 1 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/tab/tab-panel.vue